
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 3h22v10.406l-.281.313L26 15.438v13.563H6v-26zm2 2v22h16V15.437l-1.719-1.719-.281-.313V4.999H8zm16 0v7.563l1 1 1-1V5h-2z"}})])
          )
        }
      }
    